import * as components from './src/components'
import VueComponents from './framework';
import Inputmask from 'inputmask';
import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

import(/* webpackMode: "eager" */ 'bootstrap').then(() => {
  import(/* webpackMode: "eager" */ 'bootstrap-datepicker').then(() => {
    import(/* webpackMode: "eager" */ 'bootstrap-datepicker/js/locales/bootstrap-datepicker.pt-BR');
  });
});

Inputmask.extendDefinitions({
  'F': {
    validator: '[0-9A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5\u0020]'
  }
});

const install = VueComponents.install

VueComponents.install = (Vue, args) => {
  install.call(VueComponents, Vue, {
    components,
    ...args,
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueComponents)
}

export default VueComponents;
